module.exports = __webpack_public_path__ + "media/dashboard/assets/images/hero/instagram-hero-get-started-2001a03f977d17b9d286caf583fc4af7.png";